var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isActive && _vm.isReady
    ? _c("div", { staticClass: "tour-container" }, [
        _c("div", { staticClass: "overlay" }),
        _vm._v(" "),
        _vm.highlightStyles
          ? _c("div", {
              staticClass: "highlight-border",
              style: _vm.highlightStyles,
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "step",
            class: _vm.arrowClass,
            style: _vm.positionStyles,
          },
          [
            _c(
              "div",
              { staticClass: "close-icon", on: { click: _vm.finishTour } },
              [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _vm.currentStep.gif
                ? _c("img", {
                    staticClass: "step-gif",
                    attrs: { src: _vm.currentStep.gif },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("h3", [_vm._v(_vm._s(_vm.currentStep.title))]),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.currentStep.content) },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "actions" }, [
                _vm.currentIndex > 0
                  ? _c(
                      "button",
                      { staticClass: "btn back", on: { click: _vm.prevStep } },
                      [_vm._v(_vm._s(_vm.$t("message.back")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "btn next", on: { click: _vm.nextStep } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.isLastStep
                            ? _vm.$t("tour.finish")
                            : _vm.$t("message.forward")
                        ) +
                        "\n                "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }